"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const CookieBanner = __importStar(require("../CookieBanner/CookieBanner"));
function Salesviewer(props) {
    let complianceCookie = CookieBanner.getComplianceCookie(props.cookiename);
    react_1.useEffect(() => {
        complianceCookie = CookieBanner.getComplianceCookie(props.cookiename);
    }, []);
    const salesViewer = () => {
        !function (s, a, l, e, sv, i, ew, er) {
            try {
                a = s[a] || s[l] || function () {
                    throw "no_xhr";
                }, sv = i = "//salesviewer.org", l = s.SV_XHR = function (d) {
                    return er = new a, er.onerror = function () {
                        if (sv != i)
                            throw "load_err";
                        sv = "//www.salesviewer.com", setTimeout(l.bind(null, d), 0);
                    }, er.onload = function () { (s.execScript || s.eval).call(er, er.responseText); }, er.open("POST", sv, !0), er.withCredentials = true, er.send(d), er;
                }, l("h_json=" + 1 * ("JSON" in s && void 0 !== JSON.parse) + "&h_wc=1&h_event=" + 1 * ("addEventListener" in s) + "&sva=" + e);
            }
            catch (x) {
                s = new Image, s.src = "//salesviewer.org/tle.gif?sva=LE-003992-002&e=" + encodeURIComponent(x);
            }
        }(window, "XDomainRequest", "XMLHttpRequest", "LE-003992-002");
    };
    react_1.useEffect(() => {
        if (complianceCookie && complianceCookie.Marketing) {
            salesViewer();
        }
    });
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("noscript", null,
            react_1.default.createElement("img", { src: "//salesviewer.org/LE-003992-002.gif", style: { visibility: "hidden" } }))));
}
exports.default = Salesviewer;
//# sourceMappingURL=Salesviewer.js.map